//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

import { CancelToken, AxiosRequestConfig, AxiosInstance } from 'axios';
import { BusinessObjectType } from '../../../Core/BusinessObjectType';
import DefaultDtoControllerProxy from './DefaultDtoControllerProxy';
import { IHookPushDTO } from '../../../DTO/IHookPushDTO';
import { IHookDTO } from '../../../DTO/IHookDTO';

//element.Name=HookController result.Name=HookController element.FullName=Digita.Tustena.UIApiControllers.BusinessObject.DTO.HookController);
/** WebApiController: HookController */
export class HookController extends DefaultDtoControllerProxy<IHookDTO>
{
	constructor (axios: AxiosInstance)
	{
		super(axios, 'Hooks', BusinessObjectType.Hook);
	}
	public Pushes(id: number, filter?: string, orderBy?: string, top: number = 20, skip: number = 0, select?: string[], cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IHookPushDTO[]>
	{
		return (this.axios.get('Hooks/Pushes?&id='+id+((filter === null || filter === undefined) ? '' : ('&$filter='+encodeURIComponent(filter)))+((orderBy === null || orderBy === undefined) ? '' : ('&$orderBy='+encodeURIComponent(orderBy)))+'&$top='+top+'&$skip='+skip+((select === null || select === undefined) ? '' : ('&$select='+select.join(','))), { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public PushesIds(id: number, filter?: string, orderBy?: string, top: number = 20, skip: number = 0, select?: string[], cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<number[]>
	{
		return (this.axios.get('Hooks/PushesIds?&id='+id+((filter === null || filter === undefined) ? '' : ('&$filter='+encodeURIComponent(filter)))+((orderBy === null || orderBy === undefined) ? '' : ('&$orderBy='+encodeURIComponent(orderBy)))+'&$top='+top+'&$skip='+skip+((select === null || select === undefined) ? '' : ('&$select='+select.join(','))), { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public GetPushLog(hookId: number, pushId: number, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IHookPushDTO>
	{
		return (this.axios.get('Hooks/GetPushLog?&hookId='+hookId+'&pushId='+pushId, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public GetFull(id: number, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IHookDTO>
	{
		return (this.axios.get('Hooks/GetFull?&id='+id, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
}
